//引入axios
import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router';
const preUrl="http://localhost:8080/"

//创建一个新的axios实例
const service = axios.create({
    baseURL:"",
    //设置超时时间，超过该时间就不会发起请求
    timeout:15000
})
service.interceptors.request.use(

    config=>{
        //？？？？？
        config.headers = {
            'Content-Type':'application/json' //配置请求头
        };

        const  token =JSON.parse(localStorage.getItem('token_info')).token;
        console.log(localStorage.getItem('token_info'))
        const  uid = localStorage.getItem('uid')
        if(typeof token == "undefined" || token == null || token == ""){
        }else {
            if (config.isToken){
                config.headers["token"]= token
                config.headers["uid"]= uid
            }


        }

        return config
    },
    error=>{
        console.log(error);
        return Promise.reject(error)
    }
)
service.interceptors.response.use(
    //请求成功处理
    response=>{

        const res=response.data
        if(res.code===0){
            return res
        }
        //token 失效
        if (res.code == 500){
            localStorage.removeItem('ms_username');
            router.push("/login")
            Message.error(res.msg)
            return res
        }
        else{
            Message.error(res.msg)
            return res
        }

    },
    error=>{
        // Message.error(error.message)
        if (JSON.stringify(error).includes('timeout')) {
            Message.error('服务器响应超时，请刷新当前页')
        }
    }
)
export default service